import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon, StatusCard } from 'components/ui';

const GateSuccess: React.FC = () => (
  <>
    <header
      className="w-full flex justify-between items-center z-30 px-7 pb-4 fixed bg-white/90 backdrop-blur-sm border-b-2 border-header-border"
      id="header"
    >
      <h1 className="font-bold truncate text-xl !leading-8 kiosk:!leading-tight kiosk:text-4xl text-default mt-3">
        <FormattedMessage id="page.finalInstructions.title" defaultMessage="Thank you" />
      </h1>
    </header>
    <div className="main-content">
      <div className="flex justify-center items-center">
        <StatusCard
          status="success"
          icon={<Icon className="fb-icon--check text-4xl text-white" />}
          title={<FormattedMessage id="gate.success.processFinished" defaultMessage="Process finished!" />}
          description={<FormattedMessage id="gate.success.gateOpens" defaultMessage="The gate should open. Thank you." />}
        />
      </div>
    </div>
  </>
);

export default GateSuccess;